var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideNcs20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65359 15.3594L4.96997 14.1191L2.07544 18.3496L7.19653 18.0156L6.49725 16.9771L11.173 14.3052L10.3294 12.6875L5.65359 15.3594Z",
    fill: "#4B4BD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.759 14.1192L15.4348 16.791L14.7668 18.0156L19.8879 18.3496L16.9934 14.1192L16.3741 15.2533L11.6984 12.5814L10.759 14.1192Z",
    fill: "#E32B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9817 1.65039L13.2083 6.21484H11.921V13.8965H10.0945V6.21484H8.75513L10.9817 1.65039Z",
    fill: "#52D052"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2514_3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16294 1.86584L6.5356 2.41477C6.00747 2.15432 5.39966 2.00461 4.74966 2.00461C3.11685 2.00461 1.7356 2.94319 1.26841 4.23655C1.25981 4.25979 1.25981 4.28508 1.26841 4.30833C1.49966 4.94954 1.95903 5.49915 2.55903 5.89426L1.99653 6.38577L2.35044 6.69543L7.51606 2.17483L7.16294 1.86584ZM1.78169 4.27209C2.22856 3.17288 3.40669 2.44211 4.74888 2.44211C5.25591 2.44211 5.73872 2.5467 6.16841 2.73538L5.74341 3.10725C5.46528 2.9261 5.1231 2.81741 4.75122 2.81741C3.82935 2.81741 3.07856 3.47366 3.07856 4.28098C3.07856 4.60637 3.20356 4.90579 3.40981 5.14915L2.91216 5.58459C2.40356 5.26467 2.00278 4.81487 1.78169 4.27209ZM3.76919 4.83538C3.65044 4.67542 3.57935 4.48538 3.57935 4.28098C3.57935 3.71565 4.10513 3.25491 4.75122 3.25491C4.9856 3.25491 5.202 3.31643 5.38481 3.42102L3.76919 4.83538ZM7.30747 2.92336L6.95669 3.2303C7.2895 3.51672 7.55278 3.86946 7.71606 4.27278C7.26919 5.372 6.09106 6.10276 4.74888 6.10276C4.42466 6.10276 4.11138 6.05901 3.8145 5.97903L3.42388 6.32083C3.83481 6.46096 4.28091 6.54026 4.74888 6.54026C6.38169 6.54026 7.76294 5.60168 8.23013 4.30833C8.23872 4.28508 8.23872 4.25979 8.23013 4.23655C8.04888 3.73274 7.727 3.2843 7.30747 2.92336Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75122 5.3063C4.69888 5.3063 4.64888 5.29878 4.59888 5.29263L4.18481 5.65562C4.36216 5.71167 4.55278 5.7438 4.752 5.7438C5.67388 5.7438 6.42466 5.08755 6.42466 4.28022C6.42466 4.10591 6.38794 3.93911 6.32388 3.78394L5.90903 4.14692C5.91606 4.19136 5.92466 4.23442 5.92466 4.28022C5.92388 4.84624 5.3981 5.3063 4.75122 5.3063Z",
    fill: "#222627"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_3843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.981689)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2514_3843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7,
    fill: "white",
    transform: "translate(0.755127 0.773438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideNcs20);
export default __webpack_public_path__ + "static/media/hide_ncs_20.d8834e1f85437a93b30e6093100d55c0.svg";
export { ForwardRef as ReactComponent };